import { PERCENT_SCALE } from '../constants/teacherSubmission.constants';
import type { TeacherDetail } from '../types/teacherSubmission.types';

interface ProfileField {
  label: string;
  isFilled: (teacher: TeacherDetail) => boolean;
}

const OPTIONAL_PROFILE_FIELDS: ProfileField[] = [
  { label: 'Photo', isFilled: (teacher) => teacher.photoUrl !== null },
  { label: 'Date of birth', isFilled: (teacher) => teacher.dateOfBirth !== null },
  { label: 'Classes', isFilled: (teacher) => teacher.classes.length > 0 },
  { label: 'Subject expertise', isFilled: (teacher) => teacher.subjectExpertise.length > 0 },
  { label: 'Teaching medium', isFilled: (teacher) => teacher.teachingMedium !== null },
  { label: 'Teaching since', isFilled: (teacher) => teacher.teachingStartDate !== null },
  { label: 'Retirement date', isFilled: (teacher) => teacher.retirementDate !== null },
  { label: 'Marital status', isFilled: (teacher) => teacher.maritalStatus !== null },
  { label: 'NID', isFilled: (teacher) => teacher.nidNumber !== null },
  { label: 'Registration ID', isFilled: (teacher) => teacher.registrationId !== null },
  { label: 'Highest degree', isFilled: (teacher) => teacher.highestDegree !== null },
  { label: 'Institution', isFilled: (teacher) => teacher.passingInstitute !== null },
  { label: 'Passing date', isFilled: (teacher) => teacher.passingDate !== null },
];

interface ProfileCompleteness {
  percent: number;
  missingLabels: string[];
}

export function getProfileCompleteness(teacher: TeacherDetail): ProfileCompleteness {
  const missingLabels = OPTIONAL_PROFILE_FIELDS.filter((field) => !field.isFilled(teacher)).map(
    (field) => field.label,
  );
  const filledCount = OPTIONAL_PROFILE_FIELDS.length - missingLabels.length;
  return {
    percent: Math.round((filledCount / OPTIONAL_PROFILE_FIELDS.length) * PERCENT_SCALE),
    missingLabels,
  };
}
